import { defineFcm } from '../shared/factory';

export const FCM_DATA_DISABLE_PETSVC_SALESFORCE_WORKER = defineFcm('data_disable_petsvc_salesforce_worker')
	.asBoolean()
	.withDefault(false)
	.toConfig();
